import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { BottomNextButton } from "components/common/BottomNextButton";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { onboardingApi } from "api/onboardingApi";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../recoil/userAtom";

export default function Goal_1() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  // TODO 리팩토링
  const handleNext = () => {
    navigate(`/onboarding_new/goal/2`);
  };

  const pageKey = "goal_1";

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
  });

  return (
    <Box
      sx={{
        // (헤더 높이를 뺀 나머지 높이에 맞추고 싶다면 적절히 계산하여 넣으면 됩니다)
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100vh - 255px)", // TODO 경험치
      }}
    >
      <Box
        sx={{
          flex: 1, // 상단 헤더와 하단 버튼 사이 남은 공간 전부 사용
          display: "flex",
          flexDirection: "column",
          justifyContent: "center", // 세로 가운데 정렬
        }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            우린 목표를 향해 나아갑니다.
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {user?.onboardingType === "h"
              ? "디스턴싱은 우울, 불안, 공황, 강박, 트라우마, 분노 등의 정신질환을 다룹니다."
              : "디스턴싱에서는 목표 달성에 필요한 훈련을 하고 기술을 익히며 변화를 만들어 갑니다."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            먼저 내가 가진 고민과 목표를 간단히 살펴보겠습니다.
          </CustomTypography>
        </Stack>
      </Box>
      <BottomNextButton disabled={false} onClick={handleNext} text={"다음"} />
    </Box>
  );
}
